module.exports = __webpack_public_path__ + "img/impact-story-2.465103f3.png";